import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	gap: 20px;
	align-items: center;

	@media (max-width: 997px) {
		gap: 8px;
	}
`;

export const TimeColumn = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TimeNumber = styled.p`
	font-size: 28px;
	line-height: 38px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	text-align: center;

	@media (max-width: 997px) {
		font-size: 22px;
		line-height: 30px;
	}
`;

export const TimeWord = styled.p`
	font-size: 14px;
	line-height: 19px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	text-align: center;

	@media (max-width: 997px) {
		font-size: 13px;
		line-height: 18px;
	}
`;

export const Divider = styled.p`
	font-size: 34px;
	line-height: 34px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};

	@media (max-width: 997px) {
		font-size: 24px;
		line-height: 52px;
	}
`;
